import { createFileRoute } from '@tanstack/react-router';

import { InputsDb } from '@/features/inputs-db/inputs-db';

export const Route = createFileRoute('/_authenticated/ingestion/')({
  component: InputsDb,
});
